import { parseNumber } from '../../utils/financeFormatters';

export const filterCashAccounts = (collection = [], term = '') => {
  const normalizedTerm = term.trim().toLowerCase();
  if (!normalizedTerm) return collection;

  return collection.filter((account) => (
    account.name?.toLowerCase().includes(normalizedTerm) ||
    account.currency?.toLowerCase().includes(normalizedTerm)
  ));
};

export const buildCashAccountForm = (account) => ({
  uuid: account.uuid,
  name: account.name || '',
  currency: account.currency || 'ARS',
  initial_balance: String(account.initial_balance ?? 0),
  exchange_rate_to_ars: '',
  current_balance: String(account.current_balance ?? 0),
  is_active: account.is_active ?? true,
});

export const buildCreateCashAccountPayload = (formData) => ({
  name: formData.name.trim(),
  currency: formData.currency,
  initial_balance: parseNumber(formData.initial_balance),
  exchange_rate_to_ars: formData.currency === 'USD'
    ? parseNumber(formData.exchange_rate_to_ars)
    : null,
});

export const buildUpdateCashAccountPayload = (formData) => ({
  name: formData.name.trim(),
  is_active: formData.is_active,
});

export const validateCashAccountForm = (formData, editMode) => {
  const validationErrors = {};
  const initialBalance = parseNumber(formData.initial_balance);
  const exchangeRate = parseNumber(formData.exchange_rate_to_ars);

  if (!formData.name.trim() || formData.name.trim().length < 2) {
    validationErrors.name = 'Ingresá un nombre de al menos 2 caracteres.';
  }

  if (!editMode && !formData.currency) {
    validationErrors.currency = 'Seleccioná la moneda.';
  }

  if (!editMode && initialBalance < 0) {
    validationErrors.initial_balance = 'El saldo inicial no puede ser negativo.';
  }

  if (!editMode && formData.currency === 'USD' && exchangeRate <= 0) {
    validationErrors.exchange_rate_to_ars = 'Ingresá una cotización mayor a cero.';
  }

  return validationErrors;
};
